import { FaPaypal, FaDollarSign } from "react-icons/fa";
import Taskbar from '../components/Taskbar';
import RotatingBackground from '../components/RotatingBackground';
import TwoColumnLayout from "../components/TwoColumnLayout";
import AppSidebar from "../components/AppSidebar";
 

const GivePage = () => {
  return (
    <RotatingBackground>
      <Taskbar />
      <TwoColumnLayout sidebar={<AppSidebar />}>
      <div className="w-full pt-[80px] min-h-screen px-4 flex items-center justify-center">
        <div className="bg-card bg-opacity-90 shadow-xl rounded-lg p-8 max-w-md w-full transition-colors duration-500">
          <h1 className="text-4xl font-bold text-text mb-6 text-center drop-shadow-lg">Your Support Counts</h1>

          <p className="text-text font-bold text-center text-lg mb-6">
            Choose your preferred method to donate:
          </p>

          {/* PayPal Button */}
          <a
            href="https://www.paypal.com/donate?hosted_button_id=YOUR_BUTTON_ID"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-blue-700 hover:bg-yellow-700 text-white py-3 px-4 rounded-lg text-lg font-semibold transition duration-200"
          >
            <FaPaypal className="text-2xl" />
            Donate with PayPal
          </a>

          {/* Cash App Button */}
          <a
            href="https://cash.app/$YourCashtag"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center mt-2 bg-green-600 hover:bg-yellow-700 text-white py-3 px-4 rounded-lg text-lg font-semibold transition duration-200"
          >
            <FaDollarSign className="text-2xl" />
            Donate with Cash App
          </a>
        </div>
      </div>
      </TwoColumnLayout>
    </RotatingBackground>
  );
};

export default GivePage;
